module.exports = __webpack_public_path__ + "static/media/dot.465e059b.svg";